import React, { Component } from 'react';
import { render } from 'react-dom';
import { Provider } from 'react-redux';

import { store } from './store';
import { mainActions } from './actions';
import VerifyAccountContainer from './containers/verify_account_container';

export default class AppVerifyAccount extends Component {
  render() {
    store.dispatch(mainActions.initState(this.props));

    return (
      <Provider store={store}>
        <VerifyAccountContainer />
      </Provider>
    );
  }
}

